import { Toast } from 'bootstrap';

document.addEventListener("DOMContentLoaded", function() {
  const adminsManagement = document.querySelector('.admins-management');
  if (adminsManagement === null) {
    return
  }

  const inviteUserPopoup = document.querySelector('.invite-user-popup');
  const addAdminPopoup = document.querySelector('.add-admin-popup');
  const toggleAddAdmin = document.querySelector('.add-admin');
  const closeAdminPopups = document.querySelector('.close-admin-popup');

  toggleAddAdmin.addEventListener('click', () => {
    addAdminPopoup.classList.toggle('d-none');
  });
  closeAdminPopups.addEventListener('click', () => {
    addAdminPopoup.classList.add('d-none');
  });

  const form = document.getElementById('new_admin'); 
  const formContainer = document.querySelector('.add-admin-popup');

  form.addEventListener('ajax:success', (event) => {
    const [data, status, xhr] = event.detail;
    formContainer.classList.add('d-none');
    form.reset();
    document.querySelectorAll('.error-message').forEach((div) => {
      div.textContent = '';
    });
    document.querySelector('#toast-notification .toast-body').textContent = '管理者が正常に作成されました。';
    const toastElement = document.getElementById('toast-notification');
    const toast = new Toast(toastElement);
    toast.show();
  });

  form.addEventListener('ajax:error', (event) => {
    const [data, status, xhr] = event.detail;
    document.querySelectorAll('.error-message').forEach((div) => {
      div.textContent = '';
    });

    data.errors.forEach((error) => {
      const field = error.split(' ')[0].toLowerCase(); // Get the field name from the error message

      switch (field) {
        case "メールアドレス":
          const errorDivEmail = document.getElementById(`email-error`);
          if (errorDivEmail) {
            errorDivEmail.textContent = error;
          }
          break;
        case "パスワード":
          const errorDivPas = document.getElementById(`password-error`);
          if (errorDivPas) {
            errorDivPas.textContent = error;
          }
          break;
        case "パスワード確認":
          const errorDivPasCfm = document.getElementById(`password_confirmation-error`);
          if (errorDivPasCfm) {
            errorDivPasCfm.textContent = error;
          }
          break;
        default:
          break;
      }
    });
  });

  const inputUser = document.querySelector('.user-search');
  const resultUsers = document.querySelector('.user-search-result');
  const clientInput = document.querySelector('.client-search');
  const clientResult = document.querySelector('.client-search-result');
  const authority = document.querySelector('#authority');
  const searchClientButton = document.querySelector('.search-client-button');

  searchClientButton.addEventListener('click', () => {
    let url = `/admin/admins/`;
    const params = new URLSearchParams();

    if (inputUser.value && inputUser.value.trim() !== '') {
      if (inputUser.dataset.userId) params.append('admin_id', inputUser.dataset.userId);
      params.append('admin_query', inputUser.value);
    }

    params.append('authority', authority.value);
  
    window.location.href = `${url}?${params.toString()}`;
  });

  userOrClientSearchPopup(inputUser, fetchUsers);
  userOrClientSearchPopup(clientInput, fetchClients);
  hideOnBlur(inputUser, resultUsers);
  hideOnBlur(clientInput, clientResult);

  let timeoutId = null
  function userOrClientSearchPopup(inputElement, fetchFunction) {
    inputElement.addEventListener('input', (e) => {
      const searchText = e.target.value.trim();
  
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
  
      timeoutId = setTimeout(function() {
        fetchFunction(searchText);
      }, 500);
    });
  }

  function hideOnBlur(inputElement, resultElement) {
    inputElement.addEventListener('blur', (e) => {
      setTimeout(() => {resultElement.classList.add('d-none');}, 150);
    });
  }

  function fetchUsers(searchText) {
    fetch(`/admin/admins/search?query=${searchText}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(users => {
      renderUsers(users);
    })
    .catch(error => {
      console.error('Error fetching users:', error);
    });
  }

  function renderUsers(users) {
    inputUser.dataset.userId = '';
    resultUsers.classList.remove('d-none');
    resultUsers.innerHTML = '';

    users.forEach(user => {
      const userElement = document.createElement('div');
      userElement.classList.add('user-result-item');

      userElement.textContent = `${user.email}`;
      userElement.dataset.userId = user.id;

      userElement.addEventListener('click', function() {
        inputUser.value = user.email;
        inputUser.dataset.userId = user.id;

        inputUser.dataset.allData = JSON.stringify(user);
        resultUsers.innerHTML = ''; // Clear results after selection
      });

      resultUsers.appendChild(userElement);
    });
  }

  function fetchClients(searchText) {
    fetch(`/admin/clients/search?query=${searchText}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(clients => {
      renderClients(clients);
    })
    .catch(error => {
      console.error('Error fetching clients:', error);
    });
  }

  function renderClients(clients) {
    clientInput.dataset.clientId = '';
    clientResult.classList.remove('d-none');
    clientResult.innerHTML = '';

    clients.forEach(client => {
      const clientElement = document.createElement('div');
      clientElement.classList.add('client-result-item');
      clientElement.textContent = client.name;
      clientElement.dataset.clientId = client.id;

      clientElement.addEventListener('click', function() {
        clientInput.value = client.name;
        clientInput.dataset.clientId = client.id;
        clientResult.innerHTML = ''; // Clear results after selection
      });

      clientResult.appendChild(clientElement);
    });
  }
});
